import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 md:h-18 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="51爆料网首页">
            <span className="text-xl md:text-2xl font-heading font-bold text-foreground-50 whitespace-nowrap">
              <span className="text-primary-500">51</span>爆料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {[
              { path: '/', label: '首页' },
              { path: '/category/mingxing-heidong', label: '明星黑料' },
              { path: '/category/zongyi-chigua', label: '综艺吃瓜' },
              { path: '/category/yingshi-jiemi', label: '影视揭秘' },
              { path: '/category/meiri-dasai', label: '每日大赛' },
            ].map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  isActive(item.path)
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/70'
                }`}
              >
                {item.label}
                {isActive(item.path) && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-400 hover:text-foreground-100 border border-foreground-700/30 hover:border-foreground-500/50'
              }`}
            >
              关于我们
            </Link>
            <a
              href="#subscribe"
              className="px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即爆料
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 hover:text-foreground-100 transition-colors cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={isMobileMenuOpen}
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-100 border-t border-background-300/30">
            <div className="px-4 py-3 flex flex-col gap-1">
              {[
                { path: '/', label: '首页' },
                { path: '/category/mingxing-heidong', label: '明星黑料' },
                { path: '/category/zongyi-chigua', label: '综艺吃瓜' },
                { path: '/category/yingshi-jiemi', label: '影视揭秘' },
                { path: '/category/meiri-dasai', label: '每日大赛' },
                { path: '/category/hulianwang-gua', label: '互联网瓜' },
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-3 py-2.5 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                    isActive(item.path)
                      ? 'text-primary-400 bg-primary-500/10'
                      : 'text-foreground-400 hover:text-foreground-100'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <div className="h-px bg-background-300/30 my-1" />
              <Link
                to="/about"
                className="px-3 py-2.5 text-sm font-medium text-foreground-400 hover:text-foreground-100 rounded-lg transition-colors whitespace-nowrap"
              >
                关于我们
              </Link>
              <a
                href="#subscribe"
                className="mt-1 px-4 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-full text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即爆料
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
